import React from 'react'

import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import TooltipIconButton from '../Buttons/TooltipIconButton'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const ActionsRow = ({ actions, buttonTitle = '', buttonTooltipTitle = '', data, onUnselect, t }) => {
  return (
    <div className='actions-row float-btm-ctr flex-row jc-ctr ai-ctr bdr-2'>
      {onUnselect &&
        <div className='actions-row-unselect'>
          <TooltipIconButton
            icon={faCircleXmark}
            title={buttonTooltipTitle}
            onClick={() => onUnselect()}
            text={buttonTitle}
          />
        </div>}
      {actions.map((action, index) => action.render(data, index, t))}
    </div>
  )
}

export default connect(mapStateToProps)(ActionsRow)
